var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing_Fill",
    "data-name": "Processing Fill",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "rgba(255,255,255,0.5)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Processing",
    transform: "translate(19.243 230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(64.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M78.661,0H64.854a.586.586,0,0,0-.586.586v17.1a.586.586,0,0,0,.172.414l1.726,1.726a.586.586,0,0,0,.829,0l1.312-1.312,1.312,1.312a.586.586,0,0,0,.829,0l1.312-1.312,1.312,1.312a.586.586,0,0,0,.829,0l1.312-1.312,1.312,1.312a.586.586,0,0,0,.829,0L79.075,18.1a.586.586,0,0,0,.172-.414V.586A.586.586,0,0,0,78.661,0Zm-7.49,4.4V3.724a.586.586,0,0,1,1.172,0v.669h.669a.586.586,0,1,1,0,1.172H71.339a.669.669,0,0,0,0,1.339h.837a1.841,1.841,0,0,1,.167,3.674v.677a.586.586,0,0,1-1.172,0v-.669H70.5a.586.586,0,0,1,0-1.172h1.674a.669.669,0,1,0,0-1.339h-.837A1.841,1.841,0,0,1,71.172,4.4ZM74.9,14.979H68.62a.586.586,0,0,1,0-1.172H74.9a.586.586,0,1,1,0,1.172Z",
    transform: "translate(-64.268)",
    fill: "rgba(255,255,255,0.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingGray);
export default __webpack_public_path__ + "static/media/billingGray.f114ec422eeb96f9a9ba63cd6fee4c6f.svg";
export { ForwardRef as ReactComponent };